<template>
  <loading v-if="loading"></loading>
  <div class="homework" v-else>
    <!-- 头部 -->
    <div class="homework-big">
      <div class="homework-top">
        <div class="homework-top-title">我的作业</div>
        <div class="homework-top-search">
          <el-input
            v-model="form.course_name"
            placeholder="请输入课程名称"
            style="width: 200px"
            clearable
          ></el-input>
          <el-input
            v-model="form.keyword"
            placeholder="请输入作业/标题关键字"
            style="width: 200px"
            clearable
          ></el-input>
          <el-select
            v-model="form.status"
            placeholder="状态"
            clearable
            style="width: 120px"
            class="filter-item"
          >
            <el-option label="未完成" value="1" />
            <el-option label="已完成" value="2" />
            <el-option label="已逾期" value="3" />
          </el-select>
          <el-button type="primary" @click="getList">搜索</el-button>
        </div>
      </div>
    </div>
    <!-- 内容 -->
    <div class="homework-content" v-if="list.length > 0">
      <div class="homework-content-big" style="overflow: auto">
        <div
          class="homework-content-left infinite-list-wrapper"
          v-infinite-scroll="load"
          infinite-scroll-disabled="disabled"
        >
          <div
            class="homework-content-left-box list"
            v-for="(item, index) in list"
            :key="index"
            @click="getDetails(index)"
            :class="active == index ? 'left-box_active' : ''"
          >
            <div class="homework-content-left-box-title">
              <div class="homework-content-left-box-title-box">
                <div class="homework-content-left-box-title-type">作业</div>
                <div class="homework-content-left-box-title-name">
                  《{{ item.schedule_homework.title }}》
                </div>
              </div>
              <img src="@/assets/image/go.png" alt="" />
            </div>
            <!-- 上课时间 -->
            <div class="homework-content-left-box-time">
              <!-- 上课老师 -->
              <div class="homework-content-left-box-time-teacher">
                <img src="@/assets/image/teacherImg.png" alt="" />
                <span>{{
                  item.class_course.teacher
                    ? item.class_course.teacher.name
                    : ""
                }}</span>
              </div>
              <!-- 课程名 -->
              <div>
                {{
                  item.class_course.school_course
                    ? item.class_course.school_course.name
                    : ""
                }}
              </div>
              <!-- 上课时间 -->
              <div>上课时间：{{ item.date }}</div>
            </div>
            <!-- 是否完成 -->
            <div class="homework-content-left-box-isok">
              <div class="homework-content-left-box-isok-time">
                <img src="@/assets/image/end.png" alt="" />
                <span>截止时间：{{ item.schedule_homework.deadline }}</span>
              </div>
              <div
                class="homework-content-left-box-isok-item"
                v-if="item.schedule_student_homework.length > 0"
              >
                <div class="homework-content-left-box-isok-item-box">
                  {{
                    item.schedule_student_homework[0].status == 1
                      ? "未完成"
                      : item.schedule_student_homework[0].status == 2 &&
                        item.schedule_student_homework[0].score
                      ? "已评分"
                      : item.schedule_student_homework[0].status == 2 &&
                        item.schedule_student_homework[0].score == null
                      ? "未评分"
                      : item.schedule_student_homework[0].status == 2
                      ? "已完成"
                      : item.schedule_student_homework[0].status == 3
                      ? "已逾期"
                      : ""
                  }}
                </div>
                <div class="homework-content-left-box-isok-item-line"></div>
                <div class="homework-content-left-box-isok-item-box">
                  查看详情
                </div>
              </div>
            </div>
          </div>
          <p class="p" v-if="workLoading">加载中...</p>
          <p class="p" v-if="noMore && list.length > 0 && !workLoading">
            没有更多了~
          </p>
        </div>
      </div>
      <div
        class="homework-content-right"
        v-loading="loadingWork"
        element-loading-text="拼命加载中"
        v-if="details"
      >
        <div class="homework-content-box">
          <div class="homework-content-right-title">
            <div class="homework-content-right-title-left">
              <div>作业</div>
              <span>《{{ details.schedule_homework.title }}》</span>
            </div>
            <div class="homework-content-right-title-right">
              <img src="@/assets/image/teacherImg.png" alt="" />
              <span>
                {{
                  details.class_course.teacher
                    ? details.class_course.teacher.name
                    : ""
                }}
              </span>
            </div>
          </div>
          <!-- 老师和时间 -->
          <div class="homework-content-right-time">
            <div class="homework-content-right-time-left">
              <span>{{
                details.class_course.school_course
                  ? details.class_course.school_course.name
                  : ""
              }}</span>
              <span>上课时间：{{ details.date }}</span>
            </div>
            <div class="homework-content-right-time-right">
              <div class="homework-content-left-box-isok-time">
                <img src="@/assets/image/end.png" alt="" />
                <span>截止时间：{{ details.schedule_homework.deadline }}</span>
              </div>
            </div>
          </div>
          <!-- 作业内容 -->
          <div class="homework-content-right-content">
            <p v-html="details.schedule_homework.content"></p>
          </div>
          <!-- 作业附件 -->
          <div
            class="homework-accessory"
            v-if="
              details.schedule_homework.files &&
              details.schedule_homework.files.length > 0
            "
          >
            <div class="homework-accessory_left">
              <img
                src="@/assets/image/files.png"
                alt=""
                style="width: 50px; height: 50px"
              />
              作业附件
            </div>
            <div
              class="homework-accessory_right"
              @click="isUpdown(details.schedule_homework.files)"
            >
              <img src="@/assets/image/updown.png" alt="" />
              去下载
            </div>
          </div>
          <div
            class="homework-content-right-postil"
            v-if="details.schedule_student_homework[0].score"
          >
            <div class="postil_item">
              评分:<span style="color: red">{{
                details.schedule_student_homework[0].score
              }}</span>
            </div>
            <div class="postil_item">
              批注:<br />
              <div style="padding-top: 5px">
                {{ details.schedule_student_homework[0].annotation }}
              </div>
            </div>
          </div>
          <!-- 去完成作业 -->
          <div
            class="homework_btn"
            style="background:#1890ff;"
            @click="toDoHomework(details.id)"
            v-else-if="
              details.schedule_student_homework[0].status == 2 &&
              details.schedule_student_homework[0].score == null
            "
          >
            查看作业
          </div>
          <div class="homework_btn" @click="toDoHomework(details.id)" v-else>
            去完成
          </div>
          <!-- 提交的作业 -->
          <!-- <template v-if="details.schedule_student_homework[0].status != 3">
            <div
              class="homework-content-right-homework"
              v-if="details.schedule_student_homework[0].file"
            >
              <div class="homework-content-right-homework-left">
                <img src="@/assets/image/zip.png" alt="" />
                <div class="homework-content-right-homework-left-right">
                  <div>
                    {{
                      JSON.parse(details.schedule_student_homework[0].file)
                        ? JSON.parse(details.schedule_student_homework[0].file)
                            .name
                        : ""
                    }}
                  </div>
                  <div>
                    {{ details.schedule_student_homework[0].finish_at }}
                  </div>
                </div>
              </div>
              <div
                v-if="details.schedule_student_homework.length > 0"
                style="cursor: pointer"
              >
                <UploadOneFile
                  v-if="details.schedule_student_homework[0].score == null"
                  :file_url="file.file"
                  :text="'重新上传'"
                  @update="update"
                  style="margin-right: 20px"
                />
              </div>
            </div>
            <UploadOneFile
              v-else
              :file_url="file.file"
              :text="'上传作业'"
              @update="update"
            />
          </template> -->
        </div>
      </div>
    </div>
    <div class="nodata" v-if="noDate">
      <img src="@/assets/image/noData.png" alt="" />
      <span>暂无结果</span>
    </div>
    <el-dialog
      :visible.sync="isShowUpdown"
      title="作业附件下载"
      width="30%"
      :center="true"
    >
      <!-- <span>这是一段信息</span> -->
      <div class="dialog-box" v-for="(item, index) in UpdownList" :key="index">
        <div class="dialog-box_left">
          <img src="@/assets/image/files.png" alt="" />
          {{ item.name }}
        </div>
        <div class="dialog-box_right" @click="download(item)">立即下载</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import request from "@/utils/request";
import UploadOneFile from "@/components/UploadOneFile/UploadOneFile.vue";
import loading from "@/components/loading/loading.vue";
export default {
  components: { UploadOneFile, loading },
  data() {
    return {
      workLoading: true,
      loading: true,
      input: "",
      list: [],
      details: null,
      file: {
        id: "",
        file: "",
      },
      form: {
        page: 1,
        limit: 10,
        course_name: "",
        keyword: "",
        status: "",
        user_id: JSON.parse(localStorage.getItem("userInfo")).id,
      },
      loadingWork: true,
      active: 0,
      noDate: false,
      isShowUpdown: false,
      UpdownList: [],
    };
  },
  created() {
    this.getList();
  },
  computed: {
    noMore() {
      return this.list.length < this.form.limit;
    },
    disabled() {
      return this.workLoading || this.noMore;
    },
  },
  methods: {
    toDoHomework(id) {
      this.$router.push({
        path: "/mine/my_study/do_homework",
        query: {
          id: id,
        },
      });
    },
    getUrlBase64(url) {
      return new Promise((resolve) => {
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        let img = new Image();
        img.crossOrigin = "Anonymous"; //允许跨域
        img.src = url;
        img.onload = function () {
          canvas.height = 300;
          canvas.width = 300;
          ctx.drawImage(img, 0, 0, 300, 300);
          let dataURL = canvas.toDataURL("image/png");
          canvas = null;
          resolve(dataURL);
        };
      });
    },
    judgeType(name) {
      let result = "";
      let suffix = "";
      try {
        var flieArr = name.split(".");
        suffix = flieArr[flieArr.length - 1];
      } catch (err) {
        suffix = "";
      }
      let imglist = ["png", "jpg", "jpeg", "bmp", "gif"];
      result = imglist.some(function (item) {
        return item == suffix;
      });
      return result;
    },
    download(item) {
      console.log(item);
      let res = this.judgeType(item.url);
      if (res) {
        this.getUrlBase64(item.url).then((base64) => {
          let link = document.createElement("a");
          link.href = base64;
          link.download = item.name;
          link.click();
        });
      } else {
        let routeUrl = item.url.replace(/http:/, "https:");
        window.open(routeUrl + "?attname=" + item.name, "_parent");
      }
    },
    isUpdown(list) {
      this.isShowUpdown = true;
      this.UpdownList = [];
      this.UpdownList = list;
    },
    load() {
      if (!this.noMore) {
        this.form.limit += 10;
        this.getList();
      }
    },
    del(index) {
      this.file.file = "";
      this.details.schedule_student_homework[0].file = "";
      this.details.schedule_student_homework[0].finish_at = "";
      console.log(this.details.schedule_student_homework[0]);
      // details.schedule_student_homework[0]
      this.$forceUpdate(); //强制更新
    },
    update(e) {
      this.file.file = "";
      this.file.file = e;
      this.getSubmit();
    },
    // 提交作业
    getSubmit() {
      request({
        url: "/api/userend/user/homeworkSubmit",
        method: "post",
        params: this.file,
      }).then((response) => {
        this.$message.success("上传成功");
        this.getList();
        this.getDetails(this.active);
        this.$forceUpdate(); //强制更新
      });
    },
    // 作业列表
    getList() {
      this.workLoading = true;
      request({
        url: "/api/userend/user/homework",
        method: "get",
        params: this.form,
      }).then((response) => {
        this.workLoading = false;
        this.loading = false;
        this.list = response.data;
        if (this.list.length > 0) {
          this.getDetails(0);
        } else {
          this.noDate = true;
        }
      });
    },
    // 作业详情
    getDetails(index) {
      this.active = index;
      this.loadingWork = true;
      request({
        url: "/api/userend/user/homeworkDetail",
        method: "get",
        params: { id: this.list[index].id },
      }).then((response) => {
        this.details = response.data;
        this.file.id = response.data.id;
        this.loadingWork = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-dialog__header {
  .el-dialog__headerbtn {
    font-size: 1.5rem;
  }
  .el-dialog__title {
    color: #1e2134;
    font-weight: 500;
    font-size: 22px;
  }
}
/deep/ .el-dialog {
  border-radius: 1rem;
}
.homework {
  .homework-big {
    position: fixed;
    top: 80px;
    width: 100%;
    margin: 0 auto;
    height: 100px;
    background: #f9fafd;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    .homework-top {
      position: fixed;
      top: 100px;
      right: 18px;
      width: 70%;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      background: #ffffff;
      border-radius: 8px;
      padding: 20px 30px;
      .homework-top-title {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #506176;
      }
      .homework-top-search {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        .el-input {
          margin-right: 15px;
        }
        .el-select {
          margin-right: 15px;
        }
      }
    }
  }
  .nodata {
    // height: calc(100vh - 600px);
    margin-top: 150px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 407px;
      height: 355px;
    }
    span {
      font-size: 22px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
    }
  }
  .left-box_active {
    border-bottom: 2px solid #3d7eff !important;
  }
  .homework-content {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-top: 100px;
    width: 100%;
    .homework-content-big {
      height: 750px;
      padding: 0 20px;
      width: 24%;
      position: fixed;
      top: 200px;
      left: 26%;
      background: #ffffff;
      border-radius: 8px;
      .homework-content-left {
        // height: 750px;
        // padding: 0 20px;
        // width: 24%;
        // position: fixed;
        // top: 200px;
        // left: 26%;
        // background: #ffffff;
        // border-radius: 8px;
        // overflow: auto;//增加滚动条
        .p {
          text-align: center;
        }

        .homework-content-left-box {
          cursor: pointer;
          border-bottom: #f9fafd 1px solid;
          padding: 20px 0;
          border: 2px solid transparent;
          // margin-top: 1px;
          .homework-content-left-box-title {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            img {
              width: 20px;
              height: 20px;
            }
            .homework-content-left-box-title-box {
              display: flex;
              flex-direction: row;
              justify-content: flex-start;
              align-items: center;
              .homework-content-left-box-title-type {
                text-align: center;
                width: 30px;
                height: 16px;
                background: #3d7eff;
                border-radius: 8px;
                font-size: 9px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #ffffff;
                line-height: 16px;
              }
              .homework-content-left-box-title-name {
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #1e2134;
              }
            }
          }
          .homework-content-left-box-time {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            margin: 18px 0;
            .homework-content-left-box-time-teacher {
              display: flex;
              flex-direction: row;
              justify-content: flex-start;
              align-items: center;
              img {
                width: 20px;
                height: 20px;
                border-radius: 50%;
              }
              span {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #506176;
                margin-left: 5px;
              }
            }
          }
          .homework-content-left-box-isok {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            .homework-content-left-box-isok-time {
              display: flex;
              flex-direction: row;
              justify-content: flex-start;
              align-items: center;
              background: #f5fafe;
              border-radius: 6px;
              padding: 5px 10px;
              img {
                width: 16px;
                height: 16px;
              }
              span {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #3d7eff;
                margin-left: 10px;
              }
            }
            .homework-content-left-box-isok-item {
              width: 38%;
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              .homework-content-left-box-isok-item-line {
                width: 2px;
                height: 15px;
                background: #f9fafd;
              }
              .homework-content-left-box-isok-item-box {
                &:nth-child(1) {
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #f24342;
                }
                &:nth-child(2) {
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #1e2134;
                }
              }
            }
          }
        }
      }
    }
    .homework-content-right {
      float: right;
      // position: absolute;
      // top: 200px;
      // right: 20px;
      width: 60%;
      .homework-content-box {
        padding: 30px;
        background: #ffffff;
        border-radius: 8px;
        .homework-content-right-title {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          .homework-content-right-title-left {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            div {
              text-align: center;
              width: 30px;
              height: 16px;
              background: #3d7eff;
              border-radius: 8px;
              font-size: 10px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #ffffff;
              line-height: 16px;
              margin-right: 10px;
            }
            span {
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #1e2134;
            }
          }
          .homework-content-right-title-right {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            width: 100px;
            margin-left: 20px;
            img {
              width: 20px;
              height: 20px;
              border-radius: 50%;
            }
            span {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #506176;
              margin-left: 5px;
            }
          }
        }
        .homework-content-right-time {
          margin: 18px 0;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          .homework-content-right-time-left {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            span {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #506176;
              &:nth-child(2) {
                margin-left: 15px;
              }
            }
          }
          .homework-content-right-time-right {
            .homework-content-left-box-isok-time {
              display: flex;
              flex-direction: row;
              justify-content: flex-start;
              align-items: center;
              background: #f5fafe;
              border-radius: 6px;
              padding: 5px 10px;
              img {
                width: 16px;
                height: 16px;
              }
              span {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #3d7eff;
                margin-left: 10px;
              }
            }
          }
        }
        .homework-content-right-content {
          padding: 10px 0;
          border-top: solid 1px #f9fafd;
          border-bottom: solid 1px #f9fafd;
          line-height: 22px;
          img {
            max-width: 100% !important;
            height: auto !important;
          }
        }
        .homework-content-right-postil {
          .postil_item {
            margin-bottom: 20px;
          }
        }
        .homework-content-right-homework {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          padding: 15px 0;
          border-bottom: solid 1px #f9fafd;
          // align-items: center;
          .homework-content-right-homework-left {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;

            img {
              width: 50px;
              height: 50px;
            }
            .homework-content-right-homework-left-right {
              margin-left: 10px;
              display: flex;
              flex-direction: column;
              justify-content: space-around;
              div {
                &:nth-child(1) {
                  font-size: 16px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #1e2134;
                }
                &:nth-child(2) {
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #858585;
                }
              }
            }
          }
          .homework-content-right-homework-right {
            width: 85px;
            height: 38px;
            background: #3d7eff;
            border-radius: 6px;
            margin-left: 10px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            // padding: 0 22px;
            img {
              width: 26px;
              height: 26px;
            }
            span {
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #ffffff;
              margin-left: 7px;
            }
          }
        }
        .el-button {
          margin-top: 20px;
        }
      }
      &_btn {
      }
    }
  }
}
.homework-accessory {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .homework-accessory_left {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .homework-accessory_right {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 105px;
    height: 38px;
    background: #3d7eff;
    border-radius: 6px;
    color: #fff;
    cursor: pointer;
    img {
      width: 20px;
      height: 20px;
      margin-right: 5px;
    }
  }
}
.dialog-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  .dialog-box_left {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    line-height: 25px;
    img {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }
  }
  .dialog-box_right {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    width: 88px;
    height: 36px;
    background: #3d7eff;
    border-radius: 6px;
    color: #fff;
  }
}
.homework_btn {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 108px;
  height: 42px;
  background: #f24342;
  border-radius: 6px;
  color: #fff;
  margin-top: 30px;
}
</style>